// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { API_BASE, FILE_BASE } from "../config";
// import "./Checkout.css";

// export default function Checkoutinfo() {
//   const token = sessionStorage.getItem("token");

//   const [cartItems, setCartItems] = useState([]);

//   const [paymentMethod, setPaymentMethod] = useState("razorpay");

//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     companyName: "",
//     pincode: "",
//     streetAddress: "",
//     contactNumber: "",
//     email: "",
//     additionalInfo: "",
//   });

//   useEffect(() => {
//     fetchCart();
//   }, []);

//   const fetchCart = async () => {
//     try {
//       const response = await axios.get(`${API_BASE}/cart`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       setCartItems(response.data);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const total = cartItems.reduce((sum, item) => sum + item.subtotal, 0);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const loadRazorpay = () => {
//     return new Promise((resolve) => {
//       const script = document.createElement("script");

//       script.src = "https://checkout.razorpay.com/v1/checkout.js";

//       script.onload = () => {
//         resolve(true);
//       };

//       script.onerror = () => {
//         resolve(false);
//       };

//       document.body.appendChild(script);
//     });
//   };

//   const placeOrder = async () => {
//     try {
//       const loaded = await loadRazorpay();

//       if (!loaded) {
//         alert("Razorpay SDK failed");
//         return;
//       }

//       // ✅ CREATE ORDER
//       const orderResponse = await axios.post(
//         `${API_BASE}/order/create-razorpay-order`,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       const razorpayOrder = orderResponse.data;

//       const options = {
//         key: "rzp_test_SpAABX9cL2aiwB",

//         amount: razorpayOrder.amount * 100,

//         currency: "INR",

//         name: "SaPra",

//         description: "Order Payment",

//         order_id: razorpayOrder.orderId,

//         method: {
//           upi: true,
//           card: true,
//           netbanking: true,
//           wallet: true,
//         },

//         config: {
//           display: {
//             blocks: {
//               upi: {
//                 name: "Pay using UPI",
//                 instruments: [
//                   {
//                     method: "upi",
//                   },
//                 ],
//               },
//             },

//             sequence: ["block.upi"],

//             preferences: {
//               show_default_blocks: true,
//             },
//           },
//         },

//         handler: async function (response) {
//           try {
//             const checkoutDto = {
//               firstName: formData.firstName,
//               lastName: formData.lastName,
//               companyName: formData.companyName,
//               pincode: formData.pincode,
//               streetAddress: formData.streetAddress,
//               contactNumber: formData.contactNumber,
//               email: formData.email,
//               additionalInfo: formData.additionalInfo,
//             };

//             // ✅ PLACE ORDER
//             const placeOrderResponse = await axios.post(
//               `${API_BASE}/order/place-order`,
//               checkoutDto,
//               {
//                 params: {
//                   razorpayPaymentId: response.razorpay_payment_id,

//                   razorpayOrderId: response.razorpay_order_id,

//                   signature: response.razorpay_signature,
//                 },

//                 headers: {
//                   Authorization: `Bearer ${token}`,
//                 },
//               },
//             );

//             console.log(placeOrderResponse.data);

//             alert("Order placed successfully");

//             window.location.href = "/shop";
//           } catch (error) {
//             console.error(error);

//             console.log(error.response);

//             alert(error?.response?.data || error.message);
//           }
//         },

//         prefill: {
//           name: `${formData.firstName} ${formData.lastName}`,

//           email: formData.email,

//           contact: formData.contactNumber,
//         },

//         theme: {
//           color: "#000000",
//         },
//       };

//       const paymentObject = new window.Razorpay(options);

//       paymentObject.open();
//     } catch (error) {
//       console.error(error);

//       alert("Something went wrong");
//     }
//   };

//   return (
//     <div className="checkout-container">
//       <div className="checkout-left">
//         <h2>Billing details</h2>

//         <div className="row">
//           <div className="field">
//             <label>First Name</label>

//             <input
//               type="text"
//               name="firstName"
//               value={formData.firstName}
//               onChange={handleChange}
//             />
//           </div>

//           <div className="field">
//             <label>Last Name</label>

//             <input
//               type="text"
//               name="lastName"
//               value={formData.lastName}
//               onChange={handleChange}
//             />
//           </div>
//         </div>

//         <div className="field">
//           <label>Company Name</label>

//           <input
//             type="text"
//             name="companyName"
//             value={formData.companyName}
//             onChange={handleChange}
//           />
//         </div>

//         <div className="field">
//           <label>PIN code</label>

//           <input
//             type="text"
//             name="pincode"
//             value={formData.pincode}
//             onChange={handleChange}
//           />
//         </div>

//         <div className="field">
//           <label>Street address</label>

//           <input
//             type="text"
//             name="streetAddress"
//             value={formData.streetAddress}
//             onChange={handleChange}
//           />
//         </div>

//         <div className="field">
//           <label>Contact Number</label>

//           <input
//             type="text"
//             name="contactNumber"
//             value={formData.contactNumber}
//             onChange={handleChange}
//           />
//         </div>

//         <div className="field">
//           <label>Email</label>

//           <input
//             type="email"
//             name="email"
//             value={formData.email}
//             onChange={handleChange}
//           />
//         </div>

//         <div className="field">
//           <textarea
//             name="additionalInfo"
//             placeholder="Additional Information"
//             value={formData.additionalInfo}
//             onChange={handleChange}
//           />
//         </div>
//       </div>

//       <div className="checkout-right">
//         <div className="summary-row-header">
//           <span>Product</span>
//           <span>Subtotal</span>
//         </div>

//         {cartItems.map((item) => (
//           <div className="summary-row" key={item.productId}>
//             <span>
//               {item.productName} x {item.quantity}
//             </span>

//             <span>Rs. {item.subtotal}</span>
//           </div>
//         ))}

//         <div className="summary-row">
//           <span>Subtotal</span>

//           <span>Rs. {total}</span>
//         </div>

//         <div className="summary-total">
//           <span>Total</span>

//           <span>Rs. {total}</span>
//         </div>

//         <div className="payment">
//           <label>
//             <input
//               type="radio"
//               checked={paymentMethod === "razorpay"}
//               onChange={() => setPaymentMethod("razorpay")}
//             />
//             Razorpay
//           </label>
//         </div>

//         <button className="order-btn" onClick={placeOrder}>
//           Place Order
//         </button>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE } from "../config";
import "./Checkout.css";

export default function Checkoutinfo() {
  const token = sessionStorage.getItem("token");

  const [cartItems, setCartItems] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState("razorpay");
  const [placingOrder, setPlacingOrder] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
    pincode: "",
    streetAddress: "",
    contactNumber: "",
    email: "",
    additionalInfo: "",
  });

  // ==========================================
  // FETCH CART
  // ==========================================

  useEffect(() => {
    fetchCart();
  }, []);

  const fetchCart = async () => {
    try {
      const response = await axios.get(`${API_BASE}/cart`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setCartItems(response.data || []);
    } catch (error) {
      console.error("Error fetching cart:", error);
    }
  };

  // ==========================================
  // TOTAL
  // ==========================================

  const total = cartItems.reduce(
    (sum, item) => sum + Number(item.subtotal || 0),
    0,
  );

  // ==========================================
  // HANDLE INPUT CHANGE
  // ==========================================

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ==========================================
  // LOAD RAZORPAY SDK
  // ==========================================

  const loadRazorpay = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }

      const existingScript = document.querySelector(
        'script[src="https://checkout.razorpay.com/v1/checkout.js"]',
      );

      if (existingScript) {
        existingScript.onload = () => resolve(true);
        existingScript.onerror = () => resolve(false);
        return;
      }

      const script = document.createElement("script");

      script.src = "https://checkout.razorpay.com/v1/checkout.js";

      script.async = true;

      script.onload = () => {
        resolve(true);
      };

      script.onerror = () => {
        resolve(false);
      };

      document.body.appendChild(script);
    });
  };

  // ==========================================
  // FORM VALIDATION
  // ==========================================

  const validateForm = () => {
    if (!formData.firstName.trim()) {
      alert("Please enter First Name");
      return false;
    }

    if (!formData.lastName.trim()) {
      alert("Please enter Last Name");
      return false;
    }

    if (!formData.pincode.trim()) {
      alert("Please enter PIN code");
      return false;
    }

    if (!formData.streetAddress.trim()) {
      alert("Please enter Street address");
      return false;
    }

    if (!formData.contactNumber.trim()) {
      alert("Please enter Contact Number");
      return false;
    }

    if (!formData.email.trim()) {
      alert("Please enter Email");
      return false;
    }

    if (cartItems.length === 0) {
      alert("Your cart is empty");
      return false;
    }

    return true;
  };

  // ==========================================
  // PLACE ORDER
  // ==========================================

  const placeOrder = async () => {
    if (!validateForm()) {
      return;
    }

    if (paymentMethod !== "razorpay") {
      alert("Please select Razorpay");
      return;
    }

    if (!token) {
      alert("Please login before placing order");
      return;
    }

    try {
      setPlacingOrder(true);

      // ======================================
      // LOAD RAZORPAY SDK
      // ======================================

      const loaded = await loadRazorpay();

      if (!loaded) {
        alert("Razorpay SDK failed to load");
        setPlacingOrder(false);
        return;
      }

      // ======================================
      // CREATE RAZORPAY ORDER
      //
      // Backend:
      //
      // POST
      // /api/Order/create-razorpay-order
      //
      // Controller:
      //
      // [HttpPost("create-razorpay-order")]
      // public async Task<IActionResult>
      // CreateRazorpayOrder()
      // {
      //     return Ok(
      //       await _service.CreateRazorpayOrder(
      //         GetUserId()
      //       )
      //     );
      // }
      // ======================================

      const orderResponse = await axios.post(
        `${API_BASE}/Order/create-razorpay-order`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log("Create Razorpay Order Response:", orderResponse.data);

      const razorpayOrder = orderResponse.data;

      console.log("========== BACKEND RAZORPAY RESPONSE ==========");
      console.log("Full Response:", razorpayOrder);

      console.log("Razorpay Key:", razorpayOrder?.key);

      console.log("Razorpay RazorpayKey:", razorpayOrder?.razorpayKey);

      console.log("Razorpay KeyId:", razorpayOrder?.keyId);

      console.log("Razorpay OrderId:", razorpayOrder?.orderId);

      console.log("Razorpay Id:", razorpayOrder?.id);

      console.log("Razorpay Amount:", razorpayOrder?.amount);

      console.log("==============================================");

      // ======================================
      // RAZORPAY KEY FROM BACKEND
      // ======================================

      const razorpayKey =
        razorpayOrder?.key ||
        razorpayOrder?.razorpayKey ||
        razorpayOrder?.keyId;

      // ======================================
      // RAZORPAY ORDER ID
      // ======================================

      const razorpayOrderId = razorpayOrder?.orderId || razorpayOrder?.id;

      // ======================================
      // AMOUNT
      // ======================================

      const razorpayAmount = razorpayOrder?.amount;

      console.log("Razorpay Key:", razorpayKey);

      console.log("Razorpay Order ID:", razorpayOrderId);

      console.log("Razorpay Amount:", razorpayAmount);

      // ======================================
      // CHECK KEY
      // ======================================

      if (!razorpayKey) {
        console.error("Razorpay key not received from backend.", razorpayOrder);

        alert("Razorpay key was not received from backend.");

        setPlacingOrder(false);
        return;
      }

      // ======================================
      // CHECK ORDER ID
      // ======================================

      if (!razorpayOrderId) {
        console.error("Razorpay Order ID not received.", razorpayOrder);

        alert("Razorpay Order ID was not received from backend.");

        setPlacingOrder(false);
        return;
      }

      // ======================================
      // CHECK AMOUNT
      // ======================================

      if (razorpayAmount === undefined || razorpayAmount === null) {
        console.error("Razorpay amount not received.", razorpayOrder);

        alert("Razorpay amount was not received from backend.");

        setPlacingOrder(false);
        return;
      }

      // ======================================
      // RAZORPAY OPTIONS
      // ======================================

      const options = {
        // ====================================
        // NO HARDCODED KEY
        // KEY COMES FROM BACKEND
        // ====================================

        key: razorpayKey,

        // Razorpay expects amount in paise
        amount: Number(razorpayAmount) * 100,

        currency: "INR",

        name: "SaPra",

        description: "Order Payment",

        order_id: razorpayOrderId,

        method: {
          upi: true,
          card: true,
          netbanking: true,
          wallet: true,
        },

        config: {
          display: {
            blocks: {
              upi: {
                name: "Pay using UPI",

                instruments: [
                  {
                    method: "upi",
                  },
                ],
              },
            },

            sequence: ["block.upi"],

            preferences: {
              show_default_blocks: true,
            },
          },
        },

        // ====================================
        // PAYMENT SUCCESS
        // ====================================

        handler: async function (response) {
          try {
            console.log("Razorpay Payment Response:", response);

            // ==================================
            // CHECKOUT DTO
            // Matches CheckoutDto
            // ==================================

            const checkoutDto = {
              firstName: formData.firstName,
              lastName: formData.lastName,
              companyName: formData.companyName,
              pincode: formData.pincode,
              streetAddress: formData.streetAddress,
              contactNumber: formData.contactNumber,
              email: formData.email,
              additionalInfo: formData.additionalInfo,
            };

            console.log("Checkout DTO:", checkoutDto);

            // ==================================
            // PLACE ORDER
            //
            // Backend:
            //
            // POST
            // /api/Order/place-order
            //
            // Controller:
            //
            // [HttpPost("place-order")]
            //
            // [FromBody] CheckoutDto dto
            //
            // [FromQuery] string
            // razorpayPaymentId
            //
            // [FromQuery] string
            // razorpayOrderId
            //
            // [FromQuery] string
            // signature
            // ==================================

            const placeOrderResponse = await axios.post(
              `${API_BASE}/Order/place-order`,
              checkoutDto,
              {
                params: {
                  razorpayPaymentId: response.razorpay_payment_id,

                  razorpayOrderId: response.razorpay_order_id,

                  signature: response.razorpay_signature,
                },

                headers: {
                  Authorization: `Bearer ${token}`,
                },
              },
            );

            console.log("Place Order Response:", placeOrderResponse.data);

            // ==================================
            // SUCCESS
            // ==================================

            alert("Order placed successfully");

            window.location.href = "/shop";
          } catch (error) {
            console.error("Place Order Error:", error);

            console.error("Backend Error Response:", error?.response?.data);

            const errorMessage =
              error?.response?.data?.message ||
              error?.response?.data ||
              error?.message ||
              "Unable to place order";

            alert(errorMessage);
          } finally {
            setPlacingOrder(false);
          }
        },

        // ====================================
        // PREFILL CUSTOMER DETAILS
        // ====================================

        prefill: {
          name: `${formData.firstName} ${formData.lastName}`.trim(),

          email: formData.email,

          contact: formData.contactNumber,
        },

        // ====================================
        // THEME
        // ====================================

        theme: {
          color: "#000000",
        },

        // ====================================
        // MODAL
        // ====================================

        modal: {
          ondismiss: () => {
            setPlacingOrder(false);
          },
        },
      };

      // ======================================
      // CREATE RAZORPAY INSTANCE
      // ======================================

      const paymentObject = new window.Razorpay(options);

      // ======================================
      // PAYMENT FAILED
      // ======================================

      paymentObject.on("payment.failed", function (response) {
        console.error("Razorpay Payment Failed:", response.error);

        alert(
          response?.error?.description || "Payment failed. Please try again.",
        );

        setPlacingOrder(false);
      });

      // ======================================
      // OPEN RAZORPAY
      // ======================================

      paymentObject.open();
    } catch (error) {
      console.error("Create Razorpay Order Error:", error);

      console.error("Backend Error:", error?.response?.data);

      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data ||
        error?.message ||
        "Something went wrong";

      alert(errorMessage);

      setPlacingOrder(false);
    }
  };

  // ==========================================
  // JSX
  // ==========================================

  return (
    <div className="checkout-container">
      {/* =====================================
          LEFT - BILLING DETAILS
      ====================================== */}

      <div className="checkout-left">
        <h2>Billing details</h2>

        <div className="row">
          <div className="field">
            <label>First Name</label>

            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
            />
          </div>

          <div className="field">
            <label>Last Name</label>

            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="field">
          <label>Company Name</label>

          <input
            type="text"
            name="companyName"
            value={formData.companyName}
            onChange={handleChange}
          />
        </div>

        <div className="field">
          <label>PIN code</label>

          <input
            type="text"
            name="pincode"
            value={formData.pincode}
            onChange={handleChange}
            maxLength="6"
          />
        </div>

        <div className="field">
          <label>Street address</label>

          <input
            type="text"
            name="streetAddress"
            value={formData.streetAddress}
            onChange={handleChange}
          />
        </div>

        <div className="field">
          <label>Contact Number</label>

          <input
            type="text"
            name="contactNumber"
            value={formData.contactNumber}
            onChange={handleChange}
          />
        </div>

        <div className="field">
          <label>Email</label>

          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </div>

        <div className="field">
          <textarea
            name="additionalInfo"
            placeholder="Additional Information"
            value={formData.additionalInfo}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* =====================================
          RIGHT - ORDER SUMMARY
      ====================================== */}

      <div className="checkout-right">
        <div className="summary-row-header">
          <span>Product</span>

          <span>Subtotal</span>
        </div>

        {cartItems.map((item) => (
          <div className="summary-row" key={item.productId}>
            <span>
              {item.productName} x {item.quantity}
            </span>

            <span>Rs. {item.subtotal}</span>
          </div>
        ))}

        <div className="summary-row">
          <span>Subtotal</span>

          <span>Rs. {total}</span>
        </div>

        <div className="summary-total">
          <span>Total</span>

          <span>Rs. {total}</span>
        </div>

        {/* ==================================
            PAYMENT METHOD
        =================================== */}

        <div className="payment">
          <label>
            <input
              type="radio"
              name="paymentMethod"
              checked={paymentMethod === "razorpay"}
              onChange={() => setPaymentMethod("razorpay")}
            />
            Razorpay
          </label>
        </div>

        {/* ==================================
            PLACE ORDER BUTTON
        =================================== */}

        <button
          className="order-btn"
          onClick={placeOrder}
          disabled={placingOrder}
        >
          {placingOrder ? "Processing..." : "Place Order"}
        </button>
      </div>
    </div>
  );
}
